<template>
  <div class="contact margin-between-section">
    <div class="row not-margin">
      <div class="col-md-12 container-info">
        <div class="row info margin-zero">
          <div class="col-lg-2 padding-zero">
            <h1>
              <img src="../assets/images/user.png" /> {{ $t('navUser.profile') }}
            </h1>
          </div>
          <div class="col-lg-10 padding-zero">
            <div class="c-header">
              <div class="container-drop">
                <a class="btn btn-action-create btn-top-a" :href="'/docs/' + $t('profile.archive_download' ) + '.pdf'" download>{{ $t('profile.pdf') }}</a>      
                <div class="dropdown">
                  <router-link class="btn dropdown-btn "
                    type="button" to = "/contact">{{ $t('nav.contact') }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="not-margin margin-between-section">
      <MyList />
    </div>
  </div>
</template>

<script>

import MyList from '@/components/MyList';

export default {
  name: "contact",
    components: {
      MyList
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      jsonDef: [
        { position: "gk", value: 1 },
        { position: "cb", value: 2 },
        { position: "lb", value: 3 },
        { position: "rb", value: 4 },
        { position: "lwb", value: 5 },
        { position: "rwb", value: 6 },
      ],
      jsonMed: [
        { position: "dm", value: 7 },
        { position: "cm", value: 8 },
        { position: "am", value: 9 },
        { position: "lm", value: 10 },
        { position: "rm", value: 11 },
      ],
      jsonDel: [
        { position: "cf", value: 12 },
        { position: "s", value: 13 },
        { position: "ss", value: 14 },
      ],
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btn-action-create {
  border: 1px solid #000;
  height: 35px;
  border-radius: 0;
  font-size: 13px;
}

ul {
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  display: inline;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.margin-zero {
  margin: 0;
}
.padding-zero {
  padding: 0;
}

.c-header {
  width: 100%;
}

.info {
  text-align: left;
  width: 100%;
}

.info h1 {
  font-size: 20px;
  font-family: "plain regular", arial;
  display: inline-block;
  float: left;
}

.container-age {
  display: inline-block;
}

.info h1 img {
  width: 20px;
  margin-right: 10px;
  margin-top: -8px;
}

.info p {
  font-size: 18px;
}

.container-info {
  display: flex;
}

.not-margin {
  margin: 0;
}
.not-padding {
  padding: 0;
}

.info-form-contact {
  text-align: left;
}

.info-form-contact h1 {
  font-size: 16px;
  font-family: "plain regular", arial;
}

.info-form-contact p {
  font-size: 8px;
  margin-top: 15px;
  color: rgb(151, 151, 151);
}

.info-form-contact a {
  font-size: 8px;
  margin-top: 15px;
  color: rgb(116, 116, 116);
  text-decoration: underline;
}

.con-i input {
  border: 0;
  border-bottom: 1px solid #000;
  width: 120px;
  font-size: 12px;
  margin-left: 5%;
}

.send-b {
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
}

.container-drop {
  float: right;
}

.dropdown {
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  margin-left: 15px;
  margin-right: 5px;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
}

.dropdown-btn {
  font-size: 13px;
}

.dropdown-item {
  font-size: 13px;
}

.instruction {
  color: #000;
  font-size: 11px !important;
  font-family: "plain regular", arial;
}

.instruction-position {
  color: rgb(138, 138, 138);
  font-size: 9px !important;
}

.camp-position {
  position: relative;
  display: inline-block;
}

.container-footer-drop {
  position: relative;
  display: inline-block;
  float: right;
}

.container-footer-drop img {
  display: inline-block;
}

.container-footer-drop p {
  display: inline-block;
  float: right;
}

.instruction-mapa {
  color: #000;
  font-size: 9px !important;
  width: 180px;
  margin-left: 10px;
}

  .btn-d {
    padding: 0.375rem 2.75rem;
  }

/* Larger than desktop */
@media (max-width: 992px) {
  .c-header{
    margin-top: 30px;
  }
}
</style>
